import { render, staticRenderFns } from "./AddRate2.vue?vue&type=template&id=04127ff8&"
import script from "./AddRate2.vue?vue&type=script&lang=js&"
export * from "./AddRate2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports